export const GOOGLE_API_KEY =
  process.env.NODE_ENV === 'production'
    ? 'AIzaSyD84EcegS41aTc5P6zzkO-C_d3rfXFArpo'
    : 'AIzaSyD84EcegS41aTc5P6zzkO-C_d3rfXFArpo';
